export const headerRoutes = [
  {
    link: "/",
    name: "Home",
  },
  {
    link: "booth-sizes",
    name: "Trade Show Display",
  },
  {
    link: "/custom-trade-show-booth-ideas",
    name: "Custom Booth",
  },
  {
    link: "/services",
    name: "Service",
  },
  {
    link: "/portfolio",
    name: "Portfolio",
  },
  {
    link: "/contact-us",
    name: "Contact Us",
  },
];

export const boothsizePageFields = [
  {
    key: "top_title",
    type: "text",
    value: "",
  },
  {
    key: "top_btn_text",
    type: "text",
    value: "",
  },
  {
    key: "booth_size_title",
    type: "text",
    value: "",
  },
  {
    key: "booth_size_subtitle",
    type: "textarea",
    value: "",
  },
  {
    key: "second_title",
    type: "text",
    value: "",
  },
  {
    key: "second_subtitle",
    type: "textarea",
    value: "",
  },
  {
    key: "second_btn_text",
    type: "text",
    value: "",
  },
  {
    key: "third_title",
    type: "text",
    value: "",
  },
  {
    key: "third_body",
    type: "body",
    value: "<p>Hello</p>",
  },
];

export const homePageFields = [
  {
    key: "main_section_title",
    type: "text",
    value: "",
  },
  {
    key: "main_section_gif",
    type: "upload",
    value: "",
  },
  {
    key: "main_section_gif_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "main_section_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "main_section_para",
    type: "text",
    value: "",
  },
  {
    key: "main_section_btn_text",
    type: "text",
    value: "",
  },
  {
    key: "service_title",
    type: "text",
    value: "",
  },
  {
    key: "service_para",
    type: "textarea",
    value: "",
  },
  {
    key: "service_card_1_title",
    type: "text",
    value: "",
  },
  {
    key: "service_card_1_para",
    type: "textarea",
    value: "",
  },
  {
    key: "service_card_1_btn",
    type: "text",
    value: "",
  },
  {
    key: "service_card_1_image",
    type: "upload",
    value: "",
  },
  {
    key: "service_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "service_card_2_title",
    type: "text",
    value: "",
  },
  {
    key: "service_card_2_para",
    type: "textarea",
    value: "",
  },
  {
    key: "service_card_2_btn",
    type: "text",
    value: "",
  },
  {
    key: "service_card_2_image",
    type: "upload",
    value: "",
  },
  {
    key: "service_card_2_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "service_card_3_title",
    type: "text",
    value: "",
  },
  {
    key: "service_card_3_para",
    type: "textarea",
    value: "",
  },
  {
    key: "service_card_3_btn",
    type: "text",
    value: "",
  },
  {
    key: "service_card_3_image",
    type: "upload",
    value: "",
  },
  {
    key: "service_card_3_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "booth_title",
    type: "text",
    value: "",
  },
  {
    key: "booth_para",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_title",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_para",
    type: "textarea",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_3_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_3_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_4_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_4_text",
    type: "text",
    value: "",
  },
  {
    key: "portfolio_title",
    type: "text",
    value: "",
  },
  {
    key: "portfolio_para",
    type: "textarea",
    value: "",
  },
  {
    key: "leading_trade_show_image",
    type: "upload",
    value: "",
  },
  {
    key: "leading_trade_show_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "leading_trade_show_title",
    type: "text",
    value: "",
  },
  {
    key: "leading_trade_show_body",
    type: "body",
    value: "",
  },
  {
    key: "faq_title",
    type: "text",
    value: "",
  },
  {
    key: "faq_sub-title",
    type: "textarea",
    value: "",
  },
  {
    key: "5th_section_faqs",
    type: "key-value-array",
    value: [
      {
        question: "",
        answer: "",
      },
    ],
  },
];

export const FAQPageFields = [
  {
    key: "heading",
    type: "text",
    value: "",
  },
  {
    key: "5th_section_faqs",
    type: "key-value-array",
    value: [
      {
        question: "",
        answer: "",
      },
    ],
  },
];

export const PrivacyPolicyPageFields = [
  {
    key: "body",
    type: "body",
    value: "",
  },
];

export const locationPageFields = [
  {
    key: "top_title", //0
    type: "text",
    value: "",
  },
  {
    key: "top_btn_text", //1
    type: "text",
    value: "",
  },
  {
    key: "2nd_section_first_h2", //2
    type: "text",
    value: "",
  },
  {
    key: "2nd_section_second_h2", // 3
    type: "text",
    value: "",
  },
  {
    key: "2nd_section_first_para", // 4
    type: "textarea",
    value: "",
  },
  {
    key: "2nd_section_second_para", //5
    type: "textarea",
    value: "",
  },
  {
    key: "3rd_section_image", //6
    type: "upload",
    value: "",
  },
  {
    key: "3rd_section_image_alt_text",
    type: "text",
    value: "",
  },
  {
    key: "3rd_section_h2", // 7
    type: "text",
    value: "",
  },
  {
    key: "3rd_section_body", // 8
    type: "body",
    value: "",
  },
  {
    key: "3rd_section_btn_text", // 9
    type: "text",
    value: "",
  },
  {
    key: "portfolio_heading", // 10
    type: "text",
    value: "",
  },
  {
    key: "portfolio_description",
    type: "text",
    value: "",
  },
  {
    key: "booth_heading", // 11
    type: "textarea",
    value: "",
  },
  {
    key: "booth_description", // 12
    type: "textarea",
    value: "",
  },
  {
    key: "last_section_title", // 13
    type: "text",
    value: "",
  },
  {
    key: "last_section_body", // 14
    type: "body",
    value: "",
  },
  {
    key: "events_title", // 15
    type: "text",
    value: "",
  },
  {
    key: "events_btn_text", // 16
    type: "text",
    value: "",
  },
];

export const customTradeShowFields = [
  {
    key: "top_title",
    type: "text",
    value: "",
  },
  {
    key: "top_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "section_1_title",
    type: "text",
    value: "",
  },
  {
    key: "section_1_para1",
    type: "text",
    value: "",
  },
  {
    key: "section_1_para2",
    type: "text",
    value: "",
  },
  {
    key: "section_2_title",
    type: "text",
    value: "",
  },
  {
    key: "section_2_para",
    type: "body",
    value: "",
  },
  {
    key: "section_2_image",
    type: "upload",
    value: "",
  },
  {
    key: "section_3_title",
    type: "text",
    value: "",
  },
  {
    key: "section_3_para",
    type: "body",
    value: "",
  },
  {
    key: "section_3_image",
    type: "upload",
    value: "",
  },
  {
    key: "section_4_title",
    type: "text",
    value: "",
  },
  {
    key: "section_4_para",
    type: "body",
    value: "",
  },
  {
    key: "section_5_title",
    type: "text",
    value: "",
  },
  {
    key: "section_5_subtitle",
    type: "text",
    value: "",
  },
];

export const tradeShowBoothDesignsPageFields = [
  {
    key: "top_title",
    type: "text",
    value: "",
  },
  {
    key: "top_title_body",
    type: "textarea",
    value: "",
  },
  {
    key: "2nd_section_title",
    type: "text",
    value: "",
  },
  {
    key: "2nd_section_body",
    type: "body",
    value: "",
  },
  {
    key: "3rd_section_image",
    type: "upload",
    value: "",
  },
  {
    key: "3rd_section_dropdown_1st_question",
    type: "text",
    value: "",
  },
  {
    key: "3rd_section_dropdown_1st_answer",
    type: "textarea",
    value: "",
  },
  {
    key: "3rd_section_dropdown_2nd_question",
    type: "text",
    value: "",
  },

  {
    key: "3rd_section_dropdown_2nd_answer",
    type: "textarea",
    value: "",
  },
  {
    key: "3rd_section_dropdown_3rd_question",
    type: "text",
    value: "",
  },
  {
    key: "3rd_section_dropdown_3rd_answer",
    type: "textarea",
    value: "",
  },
  {
    key: "3rd_section_dropdown_4th_question",
    type: "text",
    value: "",
  },
  {
    key: "3rd_section_dropdown_4th_answer",
    type: "textarea",
    value: "",
  },
];

export const contactUsPageFields = [
  // USA Office Fields
  {
    key: "usa_whatsapp_number",
    type: "text",
    value: "+1 702 992 0440",
  },
  {
    key: "usa_phone_number",
    type: "text",
    value: "+1 702 992 0440",
  },
  {
    key: "usa_email",
    type: "text",
    value: "info@chronicleexhibits.com",
  },
  {
    key: "usa_address",
    type: "textarea",
    value: "8465, W. Sahara Ave, Suite 111 Unit #1183, Las Vegas, NV 89117, US",
  },
  {
    key: "qr_code_image",
    type: "upload",
    value: "",
  },
  {
    key: "usa_map_iframe",
    type: "iframe",
    value:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d25775.73460659082!2d-115.276006!3d36.143021!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8c1edca3c4097%3A0x3d67c01115c86d20!2sChronicle%20Exhibits%20LLC%20%7C%20Trade%20Show%20Booth%20Rental%20Company!5e0!3m2!1sen!2sin!4v1735836505245!5m2!1sen!2sin",
  },

  // Dubai Office Fields
  {
    key: "dubai_phone_number",
    type: "text",
    value: "+971 5434-74-645",
  },
  {
    key: "dubai_email",
    type: "text",
    value: "info@chronicleexhibits.ae",
  },
  {
    key: "dubai_address",
    type: "textarea",
    value: "Street 5 Lootah Warehouses, 11th St - Mina Jebel Ali - Dubai",
  },

  // Europe Office Fields
  {
    key: "europe_phone_number",
    type: "text",
    value: "+49 (1) 5217 473-031",
  },
  {
    key: "europe_email",
    type: "text",
    value: "info@chronicleexhibits.eu",
  },
  {
    key: "europe_address",
    type: "textarea",
    value: "Street 5 Lootah Warehouses, 11th St - Mina Jebel Ali - Dubai",
  },
];

export const servicePageFields = [
  {
    key: "top_title",
    type: "text",
    value: "",
  },
  {
    key: "slider1_image",
    type: "upload",
    value: "",
  },
  {
    key: "slider1_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "slider1_heading",
    type: "text",
    value: "",
  },
  {
    key: "slider1_description",
    type: "textarea",
    value: "",
  },
  {
    key: "slider2_image",
    type: "upload",
    value: "",
  },
  {
    key: "slider2_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "slider2_heading",
    type: "text",
    value: "",
  },
  {
    key: "slider2_description",
    type: "textarea",
    value: "",
  },
  {
    key: "slider3_image",
    type: "upload",
    value: "",
  },
  {
    key: "slider3_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "slider3_heading",
    type: "text",
    value: "",
  },
  {
    key: "slider3_description",
    type: "textarea",
    value: "",
  },
  {
    key: "slider4_image",
    type: "upload",
    value: "",
  },
  {
    key: "slider4_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "slider4_heading",
    type: "text",
    value: "",
  },
  {
    key: "slider4_description",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_title",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_para",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_section_1_left_icon",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_1_left_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_1_left_description",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_section_1_right_title",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_1_right_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_1_right_image",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_1_right_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_2_left_icon",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_2_left_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_2_left_description",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_section_2_right_title",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_2_right_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_2_right_image",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_2_right_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_3_left_icon",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_3_left_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_3_left_description",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_section_3_right_title",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_3_right_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_3_right_image",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_3_right_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_4_left_icon",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_4_left_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_4_left_description",
    type: "textarea",
    value: "",
  },
  {
    key: "bottom_box_section_4_right_title",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_4_right_subtitle",
    type: "text",
    value: "",
  },
  {
    key: "bottom_box_section_4_right_image",
    type: "upload",
    value: "",
  },
  {
    key: "bottom_box_section_4_right_image_alt-text",
    type: "text",
    value: "",
  },
];

export const aboutUsPageFields = [
  {
    key: "about_us_title",
    type: "text",
    value: "",
  },
  {
    key: "2nd_title",
    type: "text",
    value: "",
  },
  {
    key: "2nd_para",
    type: "body",
    value: "",
  },
  {
    key: "why_choose_us_title",
    type: "text",
    value: "",
  },
  {
    key: "why_choose_us_image",
    type: "upload",
    value: "",
  },
  {
    key: "why_choose_us_image_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "why_choose_us_body",
    type: "body",
    value: "",
  },
  {
    key: "why_choose_us_btn_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_title",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_para",
    type: "textarea",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_icon",
    type: "upload",
    value: "",
  },
  {
    key: "facts_and_figures_card_1_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_icon",
    type: "upload",
    value: "",
  },
  {
    key: "facts_and_figures_card_2_icon_alt-text",
    type: "texxt",
    value: "",
  },
  {
    key: "facts_and_figures_3_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_3_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_3_icon",
    type: "upload",
    value: "",
  },
  {
    key: "facts_and_figures_3_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_4_number",
    type: "number",
    value: "",
  },
  {
    key: "facts_and_figures_4_text",
    type: "text",
    value: "",
  },
  {
    key: "facts_and_figures_4_icon",
    type: "upload",
    value: "",
  },
  {
    key: "facts_and_figures_4_icon_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_title",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_para",
    type: "textarea",
    value: "",
  },
  {
    key: "manufacturing_image_1",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_1_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_image_2",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_2_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_image_3",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_3_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_image_4",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_4_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_image_5",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_5_alt-text",
    type: "text",
    value: "",
  },
  {
    key: "manufacturing_image_6",
    type: "upload",
    value: "",
  },
  {
    key: "manufacturing_image_6_alt-text",
    type: "text",
    value: "",
  },
];

// db.pages.updateOne(
//   { name: "trade-show-booth-displays-designs" },
//   {
//     $set: {
//       fields: [
//         {
//           key: "top_title",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "top_title_body",
//           type: "textarea",
//           value: "",
//         },
//         {
//           key: "2nd_section_title",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "2nd_section_body",
//           type: "body",
//           value: "",
//         },
//         {
//           key: "3rd_section_image",
//           type: "upload",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_1st_question",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_1st_answer",
//           type: "textarea",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_2nd_question",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_2nd_answer",
//           type: "textarea",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_3rd_question",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_3rd_answer",
//           type: "textarea",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_4th_question",
//           type: "text",
//           value: "",
//         },
//         {
//           key: "3rd_section_dropdown_4th_answer",
//           type: "textarea",
//           value: "",
//         },
//       ],
//     },
//   }
// );
